export default "__VITE_ASSET__DrC1oGeC__"